import { useNavigate, useSearchParams } from 'react-router-dom'

import { ErrorScreen, Header } from '@paysense-india-services/elevate-web'

import { EMI_SCHEDULE_API } from '@/constants/api'

import { useFetch } from '@/hooks/useFetch'

import PageLoader from '@/components/PageLoader'

import getEmiScheduleComponent from '@/app/pages/emiSchedule/utils'

import styles from './page.module.scss'

const EmiSchedulePage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const loanId = searchParams.get('loan_id') || searchParams.get('loanId')

  const {
    data: pageData,
    loading,
    error,
    apiRequest
  } = useFetch(`${EMI_SCHEDULE_API}/${loanId}`, false, true)

  // const pageData = data || mockEmiScheduleData

  if (loading) {
    return <PageLoader isLoading={loading} />
  }
  if (error) {
    return (
      <ErrorScreen
        buttonText='Try again'
        description='Please try again or check back later. Maybe give your phone a nice slap? Hey, it works on the TV remote.'
        onButtonClick={apiRequest}
        title='Something went wrong'
      />
    )
  }

  const screen = pageData?.screen ?? pageData

  return (
    <>
      <Header
        className='ew-bg-secondary ew-shadow-none ew-border-bottom'
        isBackButton={true}
        isPageTitle={true}
        onBack={() => navigate(-1)}
        style={{ top: 0 }}
        title='EMI schedule'
      />
      <div className={`${styles.container} ew-overflow-y-auto ew-pb-16`}>
        {screen?.sections?.items?.map((section, index) => getEmiScheduleComponent(section, index))}
      </div>
    </>
  )
}

export default EmiSchedulePage
